import { Box, SxProps, Theme } from '@mui/material';

const navigationStyles: SxProps<Theme> = {
  width: '100%',
  marginTop: '15px',
  marginBottom: '30px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: '15px',
};

interface NavigatorLayoutProps {
  children: React.ReactNode;
}

export const NavigatorLayout = ({ children }: NavigatorLayoutProps) => {
  return <Box sx={navigationStyles}>{children}</Box>;
};
